/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { useResource, type UseResourceHookResponse } from '@atlassian/react-resource-router';
import type { GICSmartFieldsFeatureResourceData } from '@jira/router-resources__gic-smart-fields/src/GICSmartFieldsFeatureResourceData.types.tsx';
import { gicSmartFieldsFeatureResource } from '@jira/router-resources__gic-smart-fields/src/useIsSmartFieldsOptIn.tsx';

export const useSmartFieldsPreferenceResource =
	(): UseResourceHookResponse<GICSmartFieldsFeatureResourceData> =>
		useResource(gicSmartFieldsFeatureResource);

export const useSmartFieldsMachineLearning = (): {
	withMachineLearning: boolean;
} => {
	const { loading: loadingJiraLabsSmartFields, data: jiraLabsSmartFieldsData } =
		useSmartFieldsPreferenceResource();

	const hasUserOptedOut = jiraLabsSmartFieldsData?.hasUserOptedOut;

	const withMachineLearning = !loadingJiraLabsSmartFields && !hasUserOptedOut;

	return {
		withMachineLearning,
	};
};
